import Talk from "talkjs";
import MiscAPI from "./services/api/misc.js";
import BrandAPI from "./services/api/brandApi.js";
import utils from "./services/utils";

const RetailerService = new MiscAPI();
const BrandService = new BrandAPI();

async function TalkSession(vueInstance, userInfo) {
  const fetchProfileMap = {
    BRAND: BrandService.getBrandMe,
    RETAILER: RetailerService.getMeRetailer,
  };

  if (!fetchProfileMap[userInfo.role]) {
    return;
  }

  const { data } = await fetchProfileMap[userInfo.role]();

  await Talk.ready;
  const me = new Talk.User({
    id: userInfo.role === "BRAND" ? userInfo.brand_id : userInfo.retailer_id,
    name: `${data.first_name} from ${userInfo.brand_id ? data.brand_name : data.store_name}`,
    email: data.email,
    role: userInfo.role,
  });
  window.talkSession = new Talk.Session({
    appId: utils.constants.TALKJS_APP_ID,
    me: me,
  });
  vueInstance.$store.commit("setNotificationSessionLoaded", true);
  window.talkSession.unreads.on("change", (unreadConversations) => {
    const amountOfUnreads = unreadConversations.length;
    vueInstance.$store.commit("setNotificationCount", amountOfUnreads);
  });
}

export default TalkSession;
